const typographyAnimation = ({ el }) => {
   const text = el.querySelector('[data-typography-text]');
   const defaultText = el.querySelector('[data-typography-constant-text]');
   const activeClass = 'typography__animate-text--active';
   const lineHeightValue = Number(el.style.lineHeight);

   const checkInView = () => {
      const position = el.getBoundingClientRect();
      const top = position.top;
      if (top < 300) {
         text.classList.add(activeClass);
         text.style.height = `${(defaultText.offsetHeight * lineHeightValue) * 2}px`;
      } else {
         text.classList.remove(activeClass);
         text.style.height = `${defaultText.offsetHeight * lineHeightValue}px`;
      }
   }

   checkInView();
   window.onscroll = function(){
      checkInView();
   };
}

export default typographyAnimation;